// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app-shell-main":"App_app-shell-main__wUuZX"};